// Library
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

// Routers
import { PATH_ANNOUNCEMENT_VIEW } from 'routes/paths'

// Use
import { useMounted } from 'use/mounted'
import { useDesktop } from 'use/media'

// Ui
import Heading from 'ui/Heading'
import Text from 'ui/Text'
import Link from 'ui/Link'
import Divider from 'ui/Divider'
import Scrollable from 'ui/Scrollable'
import Skeleton from 'ui/Skeleton'
import HTMLViewer from 'ui/HTMLViewer'

// Icons
import IconAnnouncement from 'ui/Icons/IconAnnouncement'

// Api
import { getAnnouncementList } from 'api/announcement'

const LatestAnnouncements = () => {
  // State
  const isMounted = useMounted()
  const history = useHistory()
  const [announcement, setAnnouncement] = useState([])
  const [loading, setLoading] = useState(false)
  const isDesktop = useDesktop()

  // Event
  useEffect(() => {
    setLoading(true)

    getAnnouncementList()
      .then((data) => {
        if (isMounted.current) {
          setAnnouncement(data)
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [history, isMounted])

  //Render
  return (
    <div className="p-2 bg-white">
      <Heading paddingTop={0} size={20}>
        <IconAnnouncement />
        <span className="ml-2">Announcements</span>
      </Heading>
      <Skeleton loading={loading}>
        <Scrollable maxHeight={isDesktop ? 450 : 250}>
          {announcement.map((item, index) => {
            return (
              <div key={index} className="pr-2">
                <Heading size={16} paddingBottom={0} paddingTop={0}>
                  {item.title}
                </Heading>
                <Text size={14} paddingBottom={10}>
                  {item.publishedAt}
                </Text>
                <HTMLViewer data={item.content} truncate={140} padding={0} />
                <Link
                  path={PATH_ANNOUNCEMENT_VIEW}
                  params={{ announcementId: item.id }}
                  underline={true}
                >
                  Read more
                </Link>
                <Divider />
              </div>
            )
          })}
        </Scrollable>
      </Skeleton>
    </div>
  )
}

export default LatestAnnouncements
